

<script>
export default {
  props: {
    titleAccess: {
      type: String,
      required: true
    },
    titleLevel: {
      type: String,
      required: true
    },
    titlePeq: {
      type: Boolean,
      required: false
    }
  },
  render(h) {
    return h(
      this.titleLevel,
      {
        attrs: {
          "aria-label": this.titleAccess
        },
        class: {
          "numbered-title": true,
          "title-peq": this.titlePeq
        }
      },
      [
        h(
          "span",
          {
            attrs: {
              "aria-hidden": "true",
              "class": "hidden-sm-and-up davi-curs font-red"              
            }
          },
          this.titleAccess
        ),
        h(
          "span",
          {
            attrs: {
              "aria-hidden": "true",
              class: "spanbig hidden-xs-only"
            }
          },
          this.$slots.partOne
        ),
        h("br", {
          attrs: {
            class: "hidden-xs-only",
            "aria-hidden": "true"
          }
        }),
        h(
          "span",
          {
            attrs: {
              "aria-hidden": "true",
              "class": "hidden-xs-only"
            }
          },
          this.$slots.partTwo
        ),
        h(
          "span",
          {
            attrs: {
              "aria-hidden": "true",
              class: "davi-curs font-red spanbig hidden-xs-only"
            }
          },
          this.$slots.partThree
        )
      ]
    );
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
@import "../../sass/helpers/mixins";
.numbered-title {
  font-size: 2rem;
  line-height: 2rem;
  font-weight: bold;
  &.title-peq {
    font-size: 1.5rem;
    line-height: 2rem;
  }
  .spanbig {
    font-size: 1.4em;
  }
}
@media (min-width: 600px) {
  .numbered-title {
    font-size: 2.7rem;
    line-height: 3.8rem;
    .spanbig {
      font-size: 1.7em;
    }
  }
}
</style>


// WEBPACK FOOTER //
// Titletwo.vue?31275a13